var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import { cx, css } from 'emotion';
import { colors } from '../../index.react';
export default (function (_a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.isActive,
      isActive = _c === void 0 ? false : _c,
      _d = _b.offset,
      offset = _d === void 0 ? '-3px' : _d,
      _e = _b.color,
      color = _e === void 0 ? colors.black : _e,
      className = _b.className;

  return cx(css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      position: relative;\n\n      &::before {\n        content: ' ';\n        position: absolute;\n        left: 0;\n        bottom: ", ";\n        height: 1px;\n        width: 100%;\n        transition: transform 250ms;\n        transform: scale(0, 1);\n        background-color: ", ";\n      }\n\n      &:hover::before {\n        transform: scale(1, 1);\n      }\n    "], ["\n      position: relative;\n\n      &::before {\n        content: ' ';\n        position: absolute;\n        left: 0;\n        bottom: ", ";\n        height: 1px;\n        width: 100%;\n        transition: transform 250ms;\n        transform: scale(0, 1);\n        background-color: ", ";\n      }\n\n      &:hover::before {\n        transform: scale(1, 1);\n      }\n    "])), offset, color), isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        &::after {\n          content: ' ';\n          position: absolute;\n          left: 0;\n          bottom: ", ";\n          width: 100%;\n          border-bottom: 3px solid ", ";\n        }\n      "], ["\n        &::after {\n          content: ' ';\n          position: absolute;\n          left: 0;\n          bottom: ", ";\n          width: 100%;\n          border-bottom: 3px solid ", ";\n        }\n      "])), offset, color), className);
});
var templateObject_1, templateObject_2;